module.exports = __webpack_public_path__ + "assets/img/btn-view-info-hover-dd1e9ded.png";